module.exports = __webpack_public_path__ + "static/media/box-bg1.6beb13d2.png";